angular.module('charts')
  .directive("dblDateRange", ['$locale', function($locale) {
    // TODO: This is intended to be a testable and reusable replacement for custom-date-range.js.

    return {
      restrict: "E",
      scope: {
        dblDateMinMax: '=',
        dblAllowCurrentDate: '='
      },
      templateUrl: '/resources/charts/directives/date-range/dbl-date-range.directive.html',
      controller: ['$scope', '$element', '$timeout', 'moment', 'dblAnalyticsProvider', 'timeframe', 'translateFilter',
        function($scope, $element, $timeout, moment, dblAnalytics, dblTimeframe, translateFilter) {

        $scope.submitEnabled = false;

        $scope.dateOptions = {
          showWeeks: false,
          formatYear: 'yy',
          startingDay: 0
        };

        $scope.formatFrom = "'" + translateFilter('shared.labels.from') + "' " + $locale.DATETIME_FORMATS.mediumDate;
        $scope.formatTo = "'" + translateFilter('shared.labels.to') + "' " + $locale.DATETIME_FORMATS.mediumDate;

        $scope.$watch('dblDateMinMax', function (newVal) {
            if (newVal) {
                $scope.fd = {
                    date: newVal.from.date,
                    minDate: newVal.from.min,
                    maxDate: newVal.from.max,
                    status: {
                        opened: false
                    }
                };

                $scope.td = {
                    date: newVal.to.date,
                    minDate: newVal.to.min,
                    maxDate: newVal.to.max,
                    status: {
                        opened: false
                    }
                };

                $scope.$watch('fd.date', onFromDateChange);
                $scope.$watch('td.date', onToDateChange);
            }
        });

        var updateSubmitEnabled = function() {
          $scope.submitEnabled = true;
        };

        var onFromDateChange = function(newValue) {
            var minMax;
            var currentDate = moment();
            var momentFrom = moment(newValue);

            // TODO: move this summer date calculation out so this can be a reusable control
            minMax = dblTimeframe.calculateCustomSummerMinMax(momentFrom, currentDate, $scope.dblAllowCurrentDate);

            $scope.td.minDate = minMax.to.min;
            $scope.td.maxDate = minMax.to.max;

            if (minMax.to.min.isAfter($scope.td.date) || minMax.to.max.isBefore($scope.td.date)) {
                $scope.td.date = minMax.to.max.toDate();
            }

            updateSubmitEnabled();
        };

        // NOTE (Russell, 2016-01-13): I would much rather have an "on change" event drive this, rather than a $watch,
        //      but I've seen references on the internets that datepicker doesn't play well with ng-change.
        var onToDateChange = function(newValue) {
          updateSubmitEnabled();
        };

        $scope.open = function($event, item) {
          $event.preventDefault();
          $event.stopPropagation();
          $timeout(function () {
            $scope[item].status.opened = !$scope[item].status.opened;

          });

          var otherItem = ( item === 'fd') ? 'td' : 'fd';
          $scope[otherItem].status.opened = false;
        };

        $scope.selectCustomDateRange = function(fd,td) {
            dblAnalytics.eventTrack('Custom Date Range Selected', {
                category: 'Resource Used',
                label: moment(fd).format('YYYYMMDD') + '-' + moment(td).format('YYYYMMDD')
            });
            $scope.$emit('customDateRangeSet', {'fd': fd, 'td': td});
        };

      }]
    };
  }]);
